import { Service } from '../classes';
interface IMyEvent {
    type: string; //'click',
    target: HTMLElement | EventTarget; //element[0],
    clientY?: number; //elementCoords.top,
    clientX?: number; //elementCoords.left
}

type IEventMap = Map<string, IMyEvent[]>;

export class EventCollectorService extends Service {
    // Probable memory leak with Map - replaced with WeakMap, see
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/WeakMap
    private _collections: WeakMap<HTMLElement, IEventMap>;

    public static get $name(): string {
        return 'eventCollector';
    }

    public static get $inject(): string[] {
        return [];
    }

    constructor() {
        super();
        this._collections = new WeakMap();
    }

    public collect(element: HTMLElement, eventName: string, count: number = 1): void {
        const elementCollection = this._getElementCollection(element);
        element &&
            element.addEventListener(eventName, (event: Event) => {
                this._setEvent(eventName, { type: event.type, target: event.target! }, elementCollection, count);
            });
    }

    public registerEvent(event: IMyEvent, count: number = 1, element: HTMLElement = document.getElementById('viewport-the-wrap')!): void {
        const eventName = event.type;
        const elementCollection = this._getElementCollection(element);
        this._setEvent(eventName, event, elementCollection, count);
    }

    public getEvents(element: HTMLElement, eventName: string, count: number = 1): IMyEvent[] | null {
        if (this._collections.get(element) && this._collections.get(element)!.get(eventName)) {
            return this._collections.get(element)!.get(eventName)!.slice(-count);
        }
        return null;
    }

    private _getElementCollection(element: HTMLElement): IEventMap {
        let elementCollection = this._collections.get(element);
        if (!elementCollection) {
            elementCollection = new Map();
            this._collections.set(element, elementCollection);
        }
        return elementCollection;
    }

    private _setEvent(eventName: string, event: IMyEvent, elementCollection: IEventMap, count: number = 1): void {
        let lastEvents = elementCollection.get(eventName);
        if (!lastEvents) {
            lastEvents = [];
        }
        while (lastEvents.length > 0 || lastEvents.length > count - 1) {
            lastEvents.pop();
        }
        lastEvents.push(event);
        elementCollection.set(eventName, lastEvents);
    }
}
